<template>
  <div class="q-pt-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      :rows="rows"
      :columns="columns"
      title-class="text-brand-5 text-weight-bold"
      :loading="disable"
      dense
      class="tabela-tamanho-fixo"
      v-model:pagination="pagination"
      color="primary"
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-name="props">
        <q-td>
          <div class="row">
            <span v-if="editar != props.row.id">
              {{ props.row.name }}
            </span>

            <q-input
              v-if="editar == props.row.id"
              dense
              outlined
              v-model="props.row.name"
              label="Nome"
            />
            <q-btn
              v-if="editar == props.row.id"
              color="positive"
              round
              class="q-ml-sm"
              icon="done"
              @click="editarRow(props.row.id, props.row.name), (editar = '')"
            />
          </div>
        </q-td>
      </template>
      <template #body-cell-criacao="props">
        <q-td>
          <span>
            {{
              props.row.created_at.split(" ")[0].split("-").reverse().join("/")
            }}
          </span>
          <span class="q-ml-sm">{{ props.row.created_at.split(" ")[1] }}</span>
        </q-td>
      </template>
      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            color="negative"
            round
            flat
            icon="delete"
            @click="abrirModalDeletar(props.row.id)"
          />
        </q-td>
      </template>
      <template #body-cell-pessoas="props">
        <q-td>
          <q-btn
            color="positive"
            round
            flat
            icon="person"
            @click="getPessoas(props.row.id)"
          />
        </q-td>
      </template>
      <template #body-cell-indexar="props">
        <q-td>
          <q-btn
            color="positive"
            round
            flat
            icon="recycling"
            @click="abrirModalIndexar(props.row.id)"
          />
        </q-td>
      </template>
      <template #body-cell-editar="props">
        <q-td>
          <q-btn
            color="primary"
            round
            flat
            icon="edit"
            @click="
              editar == props.row.id ? (editar = '') : (editar = props.row.id)
            "
          />
        </q-td>
      </template>
      <template #body-cell-epi="props">
        <q-td>
          <q-btn
            color="primary"
            round
            flat
            icon="headphones"
            @click="getEPI(props.row)"
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>

    <!-- Modal de confirmação para indexar -->
    <DialogConfirmDesign
      :mensagem="modalIndexar.mensagem"
      :exibir="modalIndexar.exibir"
      :titulo="modalIndexar.titulo"
      @resultado="confirmarIndexar"
    />

    <!-- Modal de confirmação para deletar -->
    <DialogConfirmDesign
      :mensagem="modalDeletar.mensagem"
      :exibir="modalDeletar.exibir"
      :titulo="modalDeletar.titulo"
      @resultado="confirmarDeletar"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "criacao",
    label: "Data Criação",
    field: "criacao",
    align: "left",
  },
  {
    name: "epi",
    label: "EPI's",
    field: "epi",
    align: "left",
  },
  {
    name: "pessoas",
    label: "Pessoas",
    field: "pessoas",
    align: "left",
  },
  {
    name: "indexar",
    label: "Indexar",
    field: "indexar",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  props: ["atualizar", "perPage"],
  components: {
    DialogConfirmDesign,
  },
  setup(props) {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const editar = ref("");
    const router = useRouter();

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    // Modais de confirmação
    const modalIndexar = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Indexação",
      funcaoId: null,
    });

    const modalDeletar = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Exclusão",
      funcaoId: null,
    });

    const getFuncao = async (page = 1, rowsPerPage = 15) => {
      disable.value = true;
      let response = await store.dispatch("processos/listarFuncao", {
        unidade: store.state.org.unidadeData.id,
        per_page: rowsPerPage,
        page: page,
        search: filter.value,
      });
      rows.value = response.data.results.data;
      pagination.value.rowsPerPage = response.data.results.per_page;
      pagination.value.rowsNumber = response.data.results.total;
      pagination.value.page = response.data.results.current_page;

      disable.value = false;
    };

    onMounted(getFuncao);

    const abrirModalIndexar = (id) => {
      modalIndexar.value.funcaoId = id;
      modalIndexar.value.mensagem = "Tem certeza que deseja Indexar?";
      modalIndexar.value.exibir = true;
    };

    const confirmarIndexar = async (confirmado) => {
      modalIndexar.value.exibir = false;

      if (!confirmado) {
        modalIndexar.value.funcaoId = null;
        return;
      }

      const function_id = modalIndexar.value.funcaoId;

      try {
        await store.dispatch("processos/indexar", {
          function_id,
        });

        $q.notify({
          message:
            "Job de re-indexação disparado, as atualizações serão feitas em background",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFuncao();
      } catch (error) {
        $q.notify({
          message: "Erro ao indexar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalIndexar.value.funcaoId = null;
    };

    const abrirModalDeletar = (id) => {
      modalDeletar.value.funcaoId = id;
      modalDeletar.value.mensagem = "Tem certeza que deseja deletar essa Função/Processo?";
      modalDeletar.value.exibir = true;
    };

    const confirmarDeletar = async (confirmado) => {
      modalDeletar.value.exibir = false;

      if (!confirmado) {
        modalDeletar.value.funcaoId = null;
        return;
      }

      const id = modalDeletar.value.funcaoId;

      try {
        await store.dispatch("processos/removerFuncao", {
          id,
        });

        $q.notify({
          message: "Linha deletada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFuncao();
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar linha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalDeletar.value.funcaoId = null;
    };

    const apagarRow = async (id) => {
      try {
        await store.dispatch("processos/removerFuncao", {
          id,
        });

        $q.notify({
          message: "Linha deletada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFuncao();
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar linha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const indexar = async (function_id) => {
      try {
        await store.dispatch("processos/indexar", {
          function_id,
        });

        $q.notify({
          message:
            "Job de re-indexação disparado, as atualizações serão feitas em background",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFuncao();
      } catch (error) {
        $q.notify({
          message: "Erro a o indexar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editarRow = async (id, nome) => {
      try {
        await store.dispatch("processos/editarFuncao", {
          nome,
          id,
        });

        $q.notify({
          message: "Linha editada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getFuncao();
      } catch (error) {
        $q.notify({
          message: "Erro ao editar linha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getPessoas = async (id) => {
      router.push({ name: "pessoas", params: { id: id } });
    };

    const getEPI = async (row) => {
      router.push({ name: "epi", params: { id: row.id, nome: row.name } });
    };

    const handleRequest = async () => {
      getFuncao(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getFuncao();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getFuncao();
      }
    );

    watch(
      () => props.perPage,
      () => {
        pagination.value.rowsPerPage = props.perPage;
        handleRequest();
      }
    );

    return {
      columns,
      rows,
      getFuncao,
      pagination,
      handleRequest,
      disable,
      filter,
      apagarRow,
      indexar,
      editar,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      editarRow,
      getPessoas,
      getEPI,
      abrirModalIndexar,
      confirmarIndexar,
      modalIndexar,
      abrirModalDeletar,
      confirmarDeletar,
      modalDeletar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
